import { type ApolloError } from "@apollo/client"
import { Button, useDisclosure, useToast, type ButtonProps } from "@chakra-ui/react"
import { useAtom } from "jotai"
import { useEffect, useState } from "react"
import { userDetailsAtom } from "../../../components/Menu/menu.store"
import { useDeleteFmpProjectMutation } from "../../../type-and-hooks"
import { ConfirmDialog } from "../confirmDialog"

interface DeleteFMPProps {
  fmpId: number | null | undefined
  onDeleteSuccess: VoidFunction
  children?: JSX.Element
  deleteButtonProps?: ButtonProps
}

export const DeleteFMP = ({ fmpId, onDeleteSuccess, children, deleteButtonProps }: DeleteFMPProps): JSX.Element => {
  const [userDetails] = useAtom(userDetailsAtom)
  const [loading, setLoading] = useState(false)
  const [deleteFMPMutation, { data: deleteFMPStatus }] = useDeleteFmpProjectMutation()
  const toast = useToast()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleError = (error: ApolloError | Error): void => {
    setLoading(false)
    toast({
      title: "Error",
      description: error?.message,
      status: "error",
      duration: 5000,
      isClosable: true
    })
  }

  const handleDeleteClick = (): void => {
    if (fmpId === undefined || fmpId === null) {
      return
    }
    onClose()

    setLoading(true)
    if (userDetails?._id) {
      const userID = userDetails?._id ?? null
      deleteFMPMutation({ variables: { deleteFmpProjectId: fmpId, deleteFmpProjectUserId: userID } }).catch(handleError)
    } else {
      const missingUserIdError = new Error("Missing userDetails ID. DeleteFMP.")
      handleError(missingUserIdError)
    }
    setLoading(false)
  }
  const showToast = (): void => {
    if (deleteFMPStatus) {
      toast({
        title: "Success",
        description: "Deleted Successfully",
        status: "success",
        duration: 5000,
        isClosable: true
      })
      onDeleteSuccess()
    }
  }

  useEffect(showToast, [deleteFMPStatus])

  return (
    <>
      {!children && (
        <Button fontSize="12px" isLoading={loading} whiteSpace="normal" variant="linkButton" fontWeight="400" onClick={onOpen}>
          Delete
        </Button>
      )}
      {children && (
        <Button fontSize="12px" isLoading={loading} whiteSpace="normal" variant="linkButton" fontWeight="400" onClick={onOpen} {...deleteButtonProps}>
          {children}
        </Button>
      )}

      <ConfirmDialog
        mainActionCallBack={handleDeleteClick}
        isOpen={isOpen}
        onClose={onClose}
        body="Are you sure you want to delete this project from your FMP ?"
      />
    </>
  )
}
